document.addEventListener('DOMContentLoaded', () => {
  const jobPage = document.querySelector('.smoothie-listing-page');

  if (jobPage) {
    const langSwitchers = document.querySelectorAll('.header-switch-language');
    langSwitchers.forEach(switcher => switcher.style.display = 'none');
  }
});